/**
 * Utility to play a notification sound
 * Uses a standard notification sound from a reliable CDN
 */
export const playNotificationSound = () => {
  try {
    const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
    audio.volume = 0.5;
    
    const playPromise = audio.play();
    
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Playback started successfully
        })
        .catch((error) => {
          // Auto-play was prevented or other error
          console.warn('Notification sound could not be played:', error);
        });
    }
  } catch (error) {
    console.error('Error playing notification sound:', error);
  }
};
